import ViewListIcon from '@material-ui/icons/ViewList';

import { OrdersByAPIList } from './List/List';


export const ordersByAPIResource = {
	list: OrdersByAPIList,
	icon: ViewListIcon,
}
